import { React, useState, useEffect, useRef, useContext } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  ContentMiddle,
} from "../../styledElements";
import { Button, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { useLocation, useNavigate } from "react-router-dom";
import LottieAnimation from "../../../Lottie";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import {
  cancelJobCard,
  getAlgorithmCompletionStatus,
  getAlgorithmCompletionStatusMultiStage,
} from "../../../Services/deckleMatchServices";
import { useInterval } from "../../../Utils/polling/pollingConfig";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext";

const PrepareJobData = (props) => {
  const stopCancellApi = useRef(false);
  const {
    stopCancelled,
    setStopCancelled,
    handleResetAll,
    handleBackPathForJC,
  } = useContext(JobCardDataContext);

  const history = useNavigate();
  const location = useLocation();
  const nextClickRef = useRef(false);
  const isCancelJobCard = useRef(true);
  const [formValues, setFormValues] = useState(getFormObject());
  const routeChange = () => {
    isCancelJobCard.current = false;
    setStopCancelled(true);
    stopCancellApi.current = true;
    history(
      handleBackPathForJC() ? "../order-summary" : "../create-new-job-cards",
      {
        state: {
          body: location.state.body,
          orderResponse: location.state.orderResponse,
          maximum_burst_factor: location.state.maximum_burst_factor,
          minimum_burst_factor: location.state.minimum_burst_factor,
          maximum_gsm: location.state.maximum_gsm,
          minimum_gsm: location.state.minimum_gsm,
          selected_rewinder: location.state.selected_rewinder,
          selected_cutter: location.state.selected_cutter,
          selected_rewinder_unit: location.state.selected_rewinder_unit,
          selected_cutter_unit: location.state.selected_cutter_unit,
          rewinder_data: location.state.rewinder_data,
          cutter_data: location.state.cutter_data,
          selected_type: location.state.selected_type,
          rewinder_minWidth: location.state.rewinder_minWidth,
          rewinder_maxWidth: location.state.rewinder_maxWidth,
          cutter_minWidth: location.state.cutter_minWidth,
          cutter_maxWidth: location.state.cutter_maxWidth,
          max_NoOfCutters: location.state.max_NoOfCutters,
          minWeight: location.state.minWeight,
          minWeight: location.state.minWeight,
          left_edge_trim: location.state.left_edge_trim,
          right_edge_trim: location.state.right_edge_trim,
          code: location.state.code,
          initital_OrderType: location.state.initital_OrderType,
          is_enabled: location.state.is_enabled,
          machine_code: location.state.machine_code,
          partitionWeightUnit: location.state.partitionWeightUnit,
          max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
          left_edge_trim_cutter: location.state.left_edge_trim_cutter,
          right_edge_trim_cutter: location.state.right_edge_trim_cutter,
          processType: location.state.processType,
        },
      }
    );
    // setFormObject(formValues);
  };

  useEffect(() => {
    return () => {
      if (stopCancelled || stopCancellApi.current) return;
      if (!nextClickRef.current) {
        cancelJobCard();
        setStopCancelled(false);
        handleResetAll("");
      }
      if (isCancelJobCard.current) setFormObject(null);
      stopCancellApi.current = false;
    };
  }, []);

  useInterval(async () => {
    try {
      let response;
      if (location.state.processType == "singleStage")
        response = await getAlgorithmCompletionStatus();
      else response = await getAlgorithmCompletionStatusMultiStage();

      // console.log("polling response first:", response.data);
      if (response.data.done) {
        nextClickRef.current = true;
        // console.log("Polling response");
        setFormObject(formValues);

        if (location.state.processType == "singleStage") {
          if (location.state.machine_type === "cutter") {
            history("../sheet-deckle-match-result", {
              state: {
                jobCards: response.data,
                body: location.state.body,
                orderResponse: location.state.orderResponse,
                maximum_burst_factor: location.state.maximum_burst_factor,
                minimum_burst_factor: location.state.minimum_burst_factor,
                maximum_gsm: location.state.maximum_gsm,
                minimum_gsm: location.state.minimum_gsm,
                selected_rewinder: location.state.selected_rewinder,
                selected_cutter: location.state.selected_cutter,
                selected_rewinder_unit: location.state.selected_rewinder_unit,
                selected_cutter_unit: location.state.selected_cutter_unit,
                rewinder_data: location.state.rewinder_data,
                cutter_data: location.state.cutter_data,
                selected_type: location.state.selected_type,
                rewinder_minWidth: location.state.rewinder_minWidth,
                rewinder_maxWidth: location.state.rewinder_maxWidth,
                cutter_minWidth: location.state.cutter_minWidth,
                cutter_maxWidth: location.state.cutter_maxWidth,
                max_NoOfCutters: location.state.max_NoOfCutters,
                minWeight: location.state.minWeight,
                minWeight: location.state.minWeight,
                left_edge_trim: location.state.left_edge_trim,
                right_edge_trim: location.state.right_edge_trim,
                code: location.state.code,
                initital_OrderType: location.state.initital_OrderType,
                is_enabled: location.state.is_enabled,
                machine_code: location.state.machine_code,
                partitionWeightUnit: location.state.partitionWeightUnit,
                max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
                left_edge_trim_cutter: location.state.left_edge_trim_cutter,
                right_edge_trim_cutter: location.state.right_edge_trim_cutter,
                processType: location.state.processType,
                // failed: response.data.failed_groups,
                // total_groups: response.data.total_groups
              },
            });
          } else {
            history("../deckle-match-result", {
              state: {
                jobCards: response.data,
                body: location.state.body,
                orderResponse: location.state.orderResponse,
                maximum_burst_factor: location.state.maximum_burst_factor,
                minimum_burst_factor: location.state.minimum_burst_factor,
                maximum_gsm: location.state.maximum_gsm,
                minimum_gsm: location.state.minimum_gsm,
                selected_rewinder: location.state.selected_rewinder,
                selected_cutter: location.state.selected_cutter,
                selected_rewinder_unit: location.state.selected_rewinder_unit,
                selected_cutter_unit: location.state.selected_cutter_unit,
                rewinder_data: location.state.rewinder_data,
                cutter_data: location.state.cutter_data,
                selected_type: location.state.selected_type,
                rewinder_minWidth: location.state.rewinder_minWidth,
                rewinder_maxWidth: location.state.rewinder_maxWidth,
                cutter_minWidth: location.state.cutter_minWidth,
                cutter_maxWidth: location.state.cutter_maxWidth,
                max_NoOfCutters: location.state.max_NoOfCutters,
                minWeight: location.state.minWeight,
                minWeight: location.state.minWeight,
                left_edge_trim: location.state.left_edge_trim,
                right_edge_trim: location.state.right_edge_trim,
                code: location.state.code,
                initital_OrderType: location.state.initital_OrderType,
                is_enabled: location.state.is_enabled,
                machine_code: location.state.machine_code,
                partitionWeightUnit: location.state.partitionWeightUnit,
                max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
                left_edge_trim_cutter: location.state.left_edge_trim_cutter,
                right_edge_trim_cutter: location.state.right_edge_trim_cutter,
                processType: location.state.processType,
                isDummyJC : location.state.isDummyJC,
                so : location.state.so,
                // failed: response.data.failed_groups,
                // total_groups: response.data.total_groups
              },
            });
          }
        } else {
          {
            // history("../deckle-match-result-multistage", {
            history("../deckle-match-result-multistage-multi-solutions", {
              state: {
                jobCards: response.data,
                body: location.state.body,
                orderResponse: location.state.orderResponse,
                maximum_burst_factor: location.state.maximum_burst_factor,
                minimum_burst_factor: location.state.minimum_burst_factor,
                maximum_gsm: location.state.maximum_gsm,
                minimum_gsm: location.state.minimum_gsm,
                selected_rewinder: location.state.selected_rewinder,
                selected_cutter: location.state.selected_cutter,
                selected_rewinder_unit: location.state.selected_rewinder_unit,
                selected_cutter_unit: location.state.selected_cutter_unit,
                rewinder_data: location.state.rewinder_data,
                cutter_data: location.state.cutter_data,
                selected_type: location.state.selected_type,
                rewinder_minWidth: location.state.rewinder_minWidth,
                rewinder_maxWidth: location.state.rewinder_maxWidth,
                cutter_minWidth: location.state.cutter_minWidth,
                cutter_maxWidth: location.state.cutter_maxWidth,
                max_NoOfCutters: location.state.max_NoOfCutters,
                minWeight: location.state.minWeight,
                minWeight: location.state.minWeight,
                left_edge_trim: location.state.left_edge_trim,
                right_edge_trim: location.state.right_edge_trim,
                code: location.state.code,
                initital_OrderType: location.state.initital_OrderType,
                is_enabled: location.state.is_enabled,
                machine_code: location.state.machine_code,
                partitionWeightUnit: location.state.partitionWeightUnit,
                max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
                left_edge_trim_cutter: location.state.left_edge_trim_cutter,
                right_edge_trim_cutter: location.state.right_edge_trim_cutter,
                processType: location.state.processType,
                // failed: response.data.failed_groups,
                // total_groups: response.data.total_groups
              },
            });
          }
        }
      }
    } catch (error) {
      // console.log(error);
    } finally {
    }
  }, 5000);

  return (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title="Preparing Job Card"
          extra={[
            <Button
              key="1"
              className="textTypeBtn textBtnIcon"
              onClick={() => {
                history("../create-new-job-cards");
              }}
            >
              {" "}
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />{" "}
              Cancel Job Card
            </Button>,
            // <Button
            //   key="1"
            //   className="themeBtn noBg noMargin"
            //   onClick={routeChange}
            // >
            //   Go Back
            // </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <ContentMiddle>
        <div className="imageAnimate">
          <div className="imageCover">
            <LottieAnimation lotti={JobcardPrepare} />
            <p>
              Our algorithms are cooking a job card for you <br />
              please wait, it will take less than a minute
            </p>
          </div>
        </div>
      </ContentMiddle>
    </RightLayoutContainer>
  );
};

export default PrepareJobData;
